import styled from 'styled-components';
import theme from '../../theme';

const Container = styled.div`
  z-index: 1;
  position: absolute;
  width: 100%;
  max-width: 600px;
  height: 100%;
  background-color: rgba(0,0,0,0.4);
  display: flex;
  top: 0;
  left: 0;
`;

const Content = styled.div`
    border-radius: 5px;
    width: calc(100% - 40px);
    box-shadow: 0px 9px 15px 0px #00000033;
    margin: auto;
    overflow-y: hidden;

    > div {
        padding: 10px 20px 20px 20px;
        background-color: #fefefe;
        overflow-y: auto;
    }
`;

const Header = styled.span`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 700;
    color: ${theme.textDark};
    background-color: #f5f5f5;
    padding: 10px 20px;
`;

export { Container, Content, Header };